import { createLoaderImp } from '../../../../../../components/ozmoit/common/loader-imp';
import { getDetailsAction } from '../actions';

const {
  useLoader: useWarningsObservationDetailsLoader,
  LoaderProvider,
} = createLoaderImp({
  action: getDetailsAction,
});

function StudentWarningsObservationDetailsLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return <LoaderProvider {...props}>{children}</LoaderProvider>;
}

export {
  StudentWarningsObservationDetailsLoader,
  useWarningsObservationDetailsLoader,
};
